const holders = ['0x142b32251c49c1bd074e3fb9610c99c7f46c7c8f','0x9f4ca0cfb7b80fee21cf18e3828069fe154de8fc']; 
export default holders